import { render, staticRenderFns } from "./UpdateRoutePrice.vue?vue&type=template&id=a0d32776&"
import script from "./UpdateRoutePrice.vue?vue&type=script&lang=js&"
export * from "./UpdateRoutePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports